
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './css/style.css';

import routes from './routes';
import configureStore from './Store';
import loadInitialState from './loadInitialState';
import rootSaga from './rootSaga';

const history = createHistory();

const initialState = loadInitialState();
const store = configureStore(initialState, routerMiddleware(history));

store.runSaga(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      {routes()}
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js